import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    tabs: {
        padding: 0,
        "& .MuiTab-root": {
            minWidth: "auto",
            padding: "0",
            margin: "0 50px 0 0",
            textTransform: "capitalize",
            fontSize: "1.3em",
        },
        "& .Mui-selected .MuiTab-wrapper": {
            color: "rgb(36,42,56)",
        },
        "& .MuiTab-wrapper": {
            color: "rgb(143,143,143)",
        },
        "& .MuiTabs-indicator": {
            height: "3px",
        },
    },
    tabPanel: {
        "& > .MuiBox-root": {
            margin: theme.spacing(3, 0),
        },
    },
    headerTitle: {
        fontWeight: 500,
        fontSize: "20px",
        color: "rgb(36,42,56)",
    },
    loadingContainer: {
        padding: "1.6em",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    }
}))